import * as types from '../constants'

const initialState = {
  advantage: {},
}

const advantages = (state = initialState, action) => {
  switch (action.type) {
    case types.GET_ALL_ADVANTAGES:
      return { ...state, advantage: action.payload }

    default:
      return state

  }
}
export default advantages



// WEBPACK FOOTER //
// ./src/store/advantages/reducer.js